import { NOTE_DATE_ENGLISH_MONTHS } from '../config';

const NOTE_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const pad = (value: number, length = 2) => String(value).padStart(length, '0');

// A date field's YYYY-MM-DD value as that day of the local calendar; null for
// any other text, a day the calendar does not have included.
export const readNoteDate = (date: string): Date | null => {
  const match = NOTE_DATE_PATTERN.exec(date);
  if (!match) {
    return null;
  }
  const [year, month, day] = match.slice(1).map(Number);
  const parsed = new Date(year, month - 1, day);
  return parsed.getFullYear() === year &&
    parsed.getMonth() === month - 1 &&
    parsed.getDate() === day
    ? parsed
    : null;
};

export const writeNoteDate = (date: Date) =>
  [
    pad(date.getFullYear(), 4),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join('-');

// As scribe prints a date field in the template's language: English as
// "5 October 2026", Russian and German as "05.10.2026", any other language
// and any other text as stored.
export const printNoteDate = (date: string, language: string | undefined) => {
  const parsed = readNoteDate(date);
  if (!parsed) {
    return date;
  }
  const day = parsed.getDate();
  const month = parsed.getMonth();
  const year = pad(parsed.getFullYear(), 4);
  switch (language?.split('-')[0]) {
    case 'en':
      return `${day} ${NOTE_DATE_ENGLISH_MONTHS[month]} ${year}`;
    case 'ru':
    case 'de':
      return `${pad(day)}.${pad(month + 1)}.${year}`;
    default:
      return date;
  }
};
